<template>
  <div>
    <svg :width="chart_size" :height="chart_size + chart_size / 3">
      <g :transform="translate">
        <g>
          <path :d="points" stroke="none" stroke-width="1" fill="rgb(180, 180, 180)" fill-opacity="0.1" />
          <path :d="points_1" stroke="#fff" stroke-width="1" fill="none" stroke-opacity="1" />
          <path :d="points_2" stroke="#fff" stroke-width="1" fill="none" stroke-opacity="1" />
          <path :d="points_3" stroke="#fff" stroke-width="1" fill="none" stroke-opacity="1" />
          <path :d="points_4" stroke="#fff" stroke-width="1" fill="none" stroke-opacity="1" />
        </g>
        <g>
          <!-- sound -->
          <g
            :width="chart_size / 10"
            :height="chart_size / 10"
            :transform="'translate(' + -chart_size / 20 + ',' + (-chart_size / 2 - chart_size / 10) + ')'"
          >
            <g :transform="'scale(' + scale + ')'">
              <g opacity="0.967308">
                <path
                  id="Oval"
                  opacity="0.967308"
                  d="M15.5 30C23.7843 30 30.5 23.2843 30.5 15C30.5 6.71573 23.7843 0 15.5 0C7.21573 0 0.5 6.71573 0.5 15C0.5 23.2843 7.21573 30 15.5 30Z"
                  fill="url(#paint0_linear_sound)"
                />
                <path
                  id="Combined Shape"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.4996 17.9416C13.8468 17.9416 12.5065 16.5624 12.5065 14.8608V10.5805C12.5065 8.87951 13.8468 7.50024 15.4996 7.50024C17.1524 7.50024 18.4926 8.87951 18.4926 10.5805V14.8608C18.4926 16.5624 17.1524 17.9416 15.4996 17.9416ZM21.1245 14.6243C21.1245 17.6314 18.8845 20.1085 16.0323 20.3856V21.403H17.4371C17.7313 21.403 17.9698 21.6486 17.9698 21.9513C17.9698 22.2541 17.7313 22.5002 17.4371 22.5002H13.562C13.2677 22.5002 13.0292 22.2541 13.0292 21.9513C13.0292 21.6486 13.2677 21.403 13.562 21.403H14.9667V20.3856C12.1146 20.1085 9.87451 17.6314 9.87451 14.6243C9.87451 14.3215 10.1131 14.076 10.4073 14.076C10.7015 14.076 10.9401 14.3215 10.9401 14.6243C10.9401 17.2116 12.9854 19.3165 15.4995 19.3165C18.0137 19.3165 20.0589 17.2116 20.0589 14.6243C20.0589 14.3215 20.2975 14.076 20.5917 14.076C20.8859 14.076 21.1245 14.3215 21.1245 14.6243Z"
                  fill="white"
                />
              </g>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.4996 17.9416C13.8468 17.9416 12.5065 16.5624 12.5065 14.8608V10.5805C12.5065 8.87951 13.8468 7.50024 15.4996 7.50024C17.1524 7.50024 18.4926 8.87951 18.4926 10.5805V14.8608C18.4926 16.5624 17.1524 17.9416 15.4996 17.9416ZM21.1245 14.6243C21.1245 17.6314 18.8845 20.1085 16.0323 20.3856V21.403H17.4371C17.7313 21.403 17.9698 21.6486 17.9698 21.9513C17.9698 22.2541 17.7313 22.5002 17.4371 22.5002H13.562C13.2677 22.5002 13.0292 22.2541 13.0292 21.9513C13.0292 21.6486 13.2677 21.403 13.562 21.403H14.9667V20.3856C12.1146 20.1085 9.87451 17.6314 9.87451 14.6243C9.87451 14.3215 10.1131 14.076 10.4073 14.076C10.7015 14.076 10.9401 14.3215 10.9401 14.6243C10.9401 17.2116 12.9854 19.3165 15.4995 19.3165C18.0137 19.3165 20.0589 17.2116 20.0589 14.6243C20.0589 14.3215 20.2975 14.076 20.5917 14.076C20.8859 14.076 21.1245 14.3215 21.1245 14.6243Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_sound"
                  x1="19.7857"
                  y1="0.127119"
                  x2="20.4107"
                  y2="30.132"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#6EE8FF" />
                  <stop offset="1" stop-color="#3885FF" />
                </linearGradient>
              </defs>
            </g>
            <text
              :x="chart_size / 20"
              :y="chart_size / 6 - chart_size / 60"
              font-family="SF Pro Display, Arial, sans-serif"
              text-anchor="middle"
              dominant-baseline="auto"
              :font-size="12 * scale + 'px'"
              font-weight="400"
              fill="#a8a8a8"
              style="font-family: SF Pro Display, Arial, sans-serif"
            >
              {{ $t('charts.pronunciation') }}
            </text>
            <text
              :x="chart_size / 20"
              :y="chart_size / 6 + chart_size / 20"
              font-family="SF Pro Display, Arial, sans-serif"
              text-anchor="middle"
              dominant-baseline="auto"
              :font-size="16 * scale + 'px'"
              font-weight="600"
              fill="#121131"
              style="font-family: SF Pro Display, Arial, sans-serif"
            >
              {{ score.pronunciation.toFixed(0) }}%
            </text>
          </g>
          <!-- fluency -->
          <g
            :width="chart_size / 10"
            :height="chart_size / 10"
            :transform="'translate(' + (chart_size / 3 + chart_size / 30) + ',' + -chart_size / 6 + ')'"
          >
            <g :transform="'scale(' + scale + ')'">
              <path
                d="M15 30.0001C23.2843 30.0001 30.0001 23.2843 30.0001 15C30.0001 6.71574 23.2843 0 15 0C6.71574 0 0 6.71574 0 15C0 23.2843 6.71574 30.0001 15 30.0001Z"
                fill="url(#paint0_linear_fluency)"
              />
              <path
                d="M8.31131 12.6712C8.04243 12.9954 8.08733 13.4762 8.41159 13.7451C8.73585 14.014 9.21669 13.9691 9.48556 13.6448L8.31131 12.6712ZM15.5838 12.8167L15.1638 13.4534C15.1759 13.4614 15.1883 13.469 15.2008 13.4763L15.5838 12.8167ZM21.6237 12.6905C21.9309 12.4023 21.9463 11.9196 21.6582 11.6124C21.37 11.3052 20.8873 11.2897 20.5801 11.5779L21.6237 12.6905ZM9.48556 13.6448C9.80753 13.2566 10.5011 12.7257 11.4675 12.5323C12.4067 12.3444 13.6629 12.4633 15.1638 13.4534L16.0038 12.1801C14.1939 10.9861 12.5319 10.7637 11.1683 11.0365C9.83198 11.3039 8.83828 12.0356 8.31131 12.6712L9.48556 13.6448ZM15.2008 13.4763C18.1846 15.2089 20.6791 13.5764 21.6237 12.6905L20.5801 11.5779C19.8267 12.2845 18.0766 13.3822 15.9668 12.1571L15.2008 13.4763Z"
                fill="white"
              />
              <path
                d="M8.31131 17.5017C8.04243 17.826 8.08733 18.3068 8.41159 18.5757C8.73585 18.8446 9.21669 18.7997 9.48556 18.4754L8.31131 17.5017ZM15.5838 17.6473L15.1638 18.284C15.1759 18.292 15.1883 18.2996 15.2008 18.3069L15.5838 17.6473ZM21.6237 17.5211C21.9309 17.2329 21.9463 16.7502 21.6582 16.443C21.37 16.1357 20.8873 16.1203 20.5801 16.4085L21.6237 17.5211ZM9.48556 18.4754C9.80753 18.0871 10.5011 17.5562 11.4675 17.3629C12.4067 17.175 13.6629 17.2938 15.1638 18.284L16.0038 17.0106C14.1939 15.8167 12.5319 15.5943 11.1683 15.8671C9.83198 16.1344 8.83828 16.8662 8.31131 17.5017L9.48556 18.4754ZM15.2008 18.3069C18.1846 20.0395 20.6791 18.407 21.6237 17.5211L20.5801 16.4085C19.8267 17.1151 18.0766 18.2128 15.9668 16.9877L15.2008 18.3069Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_fluency"
                  x1="19.0378"
                  y1="4.20701"
                  x2="19.0378"
                  y2="35.0566"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFD951" />
                  <stop offset="0.776042" stop-color="#FF9C28" />
                </linearGradient>
              </defs>
            </g>
            <text
              :x="chart_size / 20"
              :y="chart_size / 6 - chart_size / 60"
              font-family="SF Pro Display, Arial, sans-serif"
              text-anchor="middle"
              dominant-baseline="auto"
              :font-size="12 * scale + 'px'"
              font-weight="400"
              fill="#a8a8a8"
              style="font-family: SF Pro Display, Arial, sans-serif"
            >
              {{ $t('charts.fluency') }}
            </text>
            <text
              :x="chart_size / 20"
              :y="chart_size / 6 + chart_size / 20"
              font-family="SF Pro Display, Arial, sans-serif"
              text-anchor="middle"
              dominant-baseline="auto"
              :font-size="16 * scale + 'px'"
              font-weight="600"
              fill="#121131"
              style="font-family: SF Pro Display, Arial, sans-serif"
            >
              {{ score.fluency.toFixed(0) }}%
            </text>
          </g>
          <!-- intonation -->
          <g
            :width="chart_size / 10"
            :height="chart_size / 10"
            :transform="'translate(' + chart_size / 6 + ',' + (chart_size / 4 + chart_size / 20) + ')'"
          >
            <g :transform="'scale(' + scale + ')'">
              <g opacity="0.967308">
                <path
                  opacity="0.967308"
                  d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
                  fill="url(#paint0_linear_intonation)"
                />
              </g>
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="6" y="8" width="17" height="14">
                <path d="M6.24976 8.74976H22.8588V21.8252H6.24976V8.74976Z" fill="white" />
              </mask>
              <g mask="url(#mask0)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.1086 15.6601H20.7374C20.5849 15.6601 20.4136 15.4458 20.4136 15.1595V11.4283C20.4136 9.95139 19.3349 8.74951 18.008 8.74951C16.6811 8.74951 15.6018 9.95139 15.6018 11.4283V16.4114V19.1458C15.6018 19.7851 15.1874 20.3251 14.6968 20.3251C14.2055 20.3251 13.7905 19.7851 13.7905 19.1458V16.4114V15.1595C13.7905 13.682 12.7111 12.4801 11.3849 12.4801C10.058 12.4801 8.97864 13.682 8.97864 15.1595C8.97864 15.447 8.80802 15.6614 8.65552 15.6614H6.99989C6.58552 15.6614 6.24927 15.997 6.24927 16.4114C6.24927 16.8258 6.58552 17.1614 6.99989 17.1614H8.65552C9.66052 17.1614 10.4793 16.2633 10.4793 15.1595C10.4793 14.5208 10.8936 13.9801 11.3849 13.9801C11.8755 13.9801 12.2905 14.5208 12.2905 15.1595V16.4114V19.1458C12.2905 20.6233 13.3699 21.8251 14.6968 21.8251C16.023 21.8251 17.1024 20.6233 17.1024 19.1458V16.4114V11.4283C17.1024 10.7895 17.5168 10.2501 18.008 10.2501C18.4993 10.2501 18.9136 10.7895 18.9136 11.4283V15.1595C18.9136 16.2626 19.7318 17.1601 20.7374 17.1601H22.1086C22.523 17.1601 22.8586 16.8245 22.8586 16.4101C22.8586 15.9958 22.523 15.6601 22.1086 15.6601Z"
                  fill="white"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_intonation"
                  x1="19.0378"
                  y1="0"
                  x2="19.0378"
                  y2="51.9735"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFB339" />
                  <stop offset="1" stop-color="#FF128E" />
                </linearGradient>
              </defs>
            </g>
            <text
              :x="chart_size / 20"
              :y="chart_size / 6 - chart_size / 60"
              font-family="SF Pro Display, Arial, sans-serif"
              text-anchor="middle"
              dominant-baseline="auto"
              :font-size="12 * scale + 'px'"
              font-weight="400"
              fill="#a8a8a8"
              style="font-family: SF Pro Display, Arial, sans-serif"
            >
              {{ $t('chart.intonation') }}
            </text>
            <text
              :x="chart_size / 20"
              :y="chart_size / 6 + chart_size / 20"
              font-family="SF Pro Display, Arial, sans-serif"
              text-anchor="middle"
              dominant-baseline="auto"
              :font-size="16 * scale + 'px'"
              font-weight="600"
              fill="#121131"
              style="font-family: SF Pro Display, Arial, sans-serif"
            >
              {{ score.intonation.toFixed(0) }}%
            </text>
          </g>
          <!-- stress -->
          <g
            :width="chart_size / 10"
            :height="chart_size / 10"
            :transform="
              'translate(' + (-chart_size / 3 + chart_size / 15) + ',' + (chart_size / 4 + chart_size / 20) + ')'
            "
          >
            <g :transform="'scale(' + scale + ')'">
              <path
                opacity="0.967308"
                d="M14.9999 29.9998C23.2841 29.9998 29.9998 23.2841 29.9998 14.9999C29.9998 6.71567 23.2841 0 14.9999 0C6.71567 0 0 6.71567 0 14.9999C0 23.2841 6.71567 29.9998 14.9999 29.9998Z"
                fill="url(#paint0_linear_stress)"
              />
              <path
                d="M9.06274 17.8999C8.54497 17.8999 8.12524 17.4802 8.12524 16.9624V12.8874C8.12524 12.3697 8.54497 11.95 9.06274 11.95C9.5805 11.95 10.0002 12.3697 10.0002 12.8874V16.9624C10.0002 17.211 9.90146 17.4495 9.72564 17.6253C9.54983 17.8011 9.31138 17.8999 9.06274 17.8999Z"
                fill="white"
              />
              <path
                d="M13.5377 22.5C13.2857 22.4967 13.0454 22.3935 12.8696 22.213C12.6937 22.0325 12.5968 21.7895 12.6002 21.5375V8.46264C12.6002 7.94488 13.0199 7.52515 13.5377 7.52515C14.0554 7.52515 14.4752 7.94488 14.4752 8.46264V21.5375C14.4785 21.7895 14.3816 22.0325 14.2058 22.213C14.03 22.3935 13.7896 22.4967 13.5377 22.5Z"
                fill="white"
              />
              <path
                d="M17.8376 20.0749C17.3199 20.0749 16.9001 19.6552 16.9001 19.1374V10.7187C16.9001 10.201 17.3199 9.78125 17.8376 9.78125C18.3554 9.78125 18.7751 10.201 18.7751 10.7187V19.1374C18.7751 19.6552 18.3554 20.0749 17.8376 20.0749Z"
                fill="white"
              />
              <path
                d="M22.144 16.4561C21.6263 16.4561 21.2065 16.0364 21.2065 15.5186V14.3374C21.2065 13.8196 21.6263 13.3999 22.144 13.3999C22.6618 13.3999 23.0815 13.8196 23.0815 14.3374V15.5186C23.0815 16.0364 22.6618 16.4561 22.144 16.4561Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_stress"
                  x1="19.0376"
                  y1="4.20696"
                  x2="19.0376"
                  y2="35.0562"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#36FF73" />
                  <stop offset="0.999789" stop-color="#0ACBFF" />
                </linearGradient>
              </defs>
            </g>
            <text
              :x="chart_size / 20"
              :y="chart_size / 6 - chart_size / 60"
              font-family="SF Pro Display, Arial, sans-serif"
              text-anchor="middle"
              dominant-baseline="auto"
              :font-size="12 * scale + 'px'"
              font-weight="400"
              fill="#a8a8a8"
              style="font-family: SF Pro Display, Arial, sans-serif"
            >
              {{ $t('charts.word_stress') }}
            </text>
            <text
              :x="chart_size / 20"
              :y="chart_size / 6 + chart_size / 20"
              font-family="SF Pro Display, Arial, sans-serif"
              text-anchor="middle"
              dominant-baseline="auto"
              :font-size="16 * scale + 'px'"
              font-weight="600"
              fill="#121131"
              style="font-family: SF Pro Display, Arial, sans-serif"
            >
              {{ score.word_stress.toFixed(0) }}%
            </text>
          </g>
          <!-- listening -->
          <g
            :width="chart_size / 10"
            :height="chart_size / 10"
            :transform="'translate(' + (-chart_size / 2 + chart_size / 30) + ',' + -chart_size / 6 + ')'"
          >
            <g :transform="'scale(' + scale + ')'">
              <path
                opacity="0.967308"
                d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
                fill="url(#paint0_linear_listening)"
              />
              <path
                d="M22.5814 14.8266C22.4639 10.7466 19.1225 7.5 15.0408 7.5C10.959 7.5 7.61765 10.7466 7.50008 14.8266V17.5704C7.49851 17.6879 7.51974 17.8047 7.56267 17.9141C7.57643 19.5927 8.94656 20.9433 10.6252 20.9329C11.1449 20.9226 11.5599 20.4965 11.5564 19.9766V15.8016C11.5599 15.2818 11.1449 14.8556 10.6252 14.8454C10.1533 14.8476 9.68866 14.9611 9.26892 15.1766V14.8266C9.37157 11.7026 11.9338 9.22315 15.0595 9.22315C18.1853 9.22315 20.7475 11.7026 20.8502 14.8266V15.1579C20.4378 14.9548 19.9848 14.848 19.5252 14.8454C19.2721 14.8454 19.0295 14.9463 18.8512 15.1258C18.6729 15.3054 18.5735 15.5486 18.5752 15.8016V19.9766C18.5735 20.2297 18.6729 20.4729 18.8512 20.6524C19.0295 20.8319 19.2721 20.9329 19.5252 20.9329C21.1892 20.9227 22.5365 19.5781 22.5502 17.9141C22.5502 17.9141 22.5502 17.8641 22.5502 17.8329C22.5722 17.7555 22.5848 17.6758 22.5877 17.5954L22.5814 14.8266Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_listening"
                  x1="19.0378"
                  y1="-7.25121"
                  x2="29.993"
                  y2="35.9765"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFA1AA" />
                  <stop offset="0.999789" stop-color="#FF5997" />
                </linearGradient>
              </defs>
            </g>
            <text
              :x="chart_size / 20"
              :y="chart_size / 6 - chart_size / 60"
              font-family="SF Pro Display, Arial, sans-serif"
              text-anchor="middle"
              dominant-baseline="auto"
              :font-size="12 * scale + 'px'"
              font-weight="400"
              fill="#a8a8a8"
              style="font-family: SF Pro Display, Arial, sans-serif"
            >
              {{ $t('charts.listening') }}
            </text>
            <text
              :x="chart_size / 20"
              :y="chart_size / 6 + chart_size / 20"
              font-family="SF Pro Display, Arial, sans-serif"
              text-anchor="middle"
              dominant-baseline="auto"
              :font-size="16 * scale + 'px'"
              font-weight="600"
              fill="#121131"
              style="font-family: SF Pro Display, Arial, sans-serif"
            >
              {{ score.listening.toFixed(0) }}%
            </text>
          </g>
        </g>
      </g>
      <!--progress pentagon-->
      <g :transform="translate">
        <g filter="url(#filter0_d_pentagon)">
          <path
            :d="points_8"
            stroke="url(#paint1_linear_pentagon)"
            stroke-width="2"
            fill="url(#paint0_linear_pentagon)"
            fill-opacity="0.3"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_pentagon"
            :x="-chart_size / 2"
            :y="-chart_size / 2"
            :width="chart_size"
            :height="chart_size"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="7" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <linearGradient id="paint0_linear_pentagon" gradientUnits="userSpaceOnUse">
            <stop stop-color="#29F4FF" />
            <stop offset="1" stop-color="#5257FF" />
          </linearGradient>
          <linearGradient id="paint1_linear_pentagon" gradientUnits="userSpaceOnUse">
            <stop stop-color="#29F4FF" />
            <stop offset="1" stop-color="#5257FF" />
          </linearGradient>
        </defs>
      </g>
    </svg>
  </div>
</template>

<script>
  export default {
    props: {
      score: {
        type: Object,
        default: () => ({}),
      },
      chart_size: {
        type: Number,
        default: () => {
          return 300;
        },
      },
      border_radius: {
        type: Number,
        default: () => {
          return 2;
        },
      },
    },
    computed: {
      scale() {
        return this.chart_size / 300;
      },
      translate() {
        return "translate(" + this.chart_size / 2 + ", " + (this.chart_size / 2 + this.chart_size / 10) + ")";
      },
      points() {
        return generatePentagonPath(this.chart_size / 3, this.border_radius);
      },
      points_1() {
        return generatePentagonPath(this.chart_size / 3 - this.chart_size / 15, this.border_radius);
      },
      points_2() {
        return generatePentagonPath(this.chart_size / 3 - (2 * this.chart_size) / 15, this.border_radius);
      },
      points_3() {
        return generatePentagonPath(this.chart_size / 3 - (3 * this.chart_size) / 15, this.border_radius);
      },
      points_4() {
        return generatePentagonPath(this.chart_size / 3 - (4 * this.chart_size) / 15, this.border_radius);
      },
      points_8() {
        return generatePathPoints(
          [
            (this.score.pronunciation * this.chart_size) / 300,
            (this.score.fluency * this.chart_size) / 300,
            (this.score.intonation * this.chart_size) / 300,
            (this.score.word_stress * this.chart_size) / 300,
            (this.score.listening * this.chart_size) / 300,
          ],
          this.border_radius
        );
      },
    },
  };
  function valueToPoint(value, index, total) {
    var angle = ((Math.PI * 2) / total) * index;
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var tx = Math.round(value * sin * 10000) / 10000;
    var ty = Math.round(-value * cos * 10000) / 10000;
    return { x: tx, y: ty };
  }

  function generatePoints(stats) {
    var total = stats.length;
    return stats
      .map(function (stat, index) {
        var point = valueToPoint(stat, index, total);
        return point.x + "," + point.y;
      })
      .join(" ");
  }

  function generatePathPoints(stats, borderRadius = 4) {
    var _lens = borderRadius;
    var lines = [];
    var total = stats.length;
    var _p = stats.map(function (stat, index) {
      return valueToPoint(stat, index, total);
    });
    for (var i = _p.length - 1; i >= 0; i--) {
      var x = _p[i];
      var y;
      if (i == 0) {
        y = _p[_p.length - 1];
      } else {
        y = _p[i - 1];
      }
      var xy = Math.sqrt((x.x - y.x) * (x.x - y.x) + (x.y - y.y) * (x.y - y.y));
      var _rates = [
        Math.round((_lens / xy) * 100) / 100,
        Math.round(((2 * _lens) / xy) * 100) / 100,
        1 - Math.round(((2 * _lens) / xy) * 100) / 100,
        1 - Math.round((_lens / xy) * 100) / 100,
      ];

      var _line = _rates.map(function (v, i) {
        return {
          x: Math.round((x.x * (1 - v) + y.x * v) * 1000) / 1000,
          y: Math.round((x.y * (1 - v) + y.y * v) * 1000) / 1000,
        };
      });
      lines.push(_line);
    }
    var first_lines = lines.slice(0, -1);
    var last_line = lines.slice(-1)[0];
    return (
      "M" +
      last_line[2].x +
      " " +
      last_line[2].y +
      "C" +
      last_line[3].x +
      " " +
      last_line[3].y +
      " " +
      first_lines
        .map(function (l, i) {
          return (
            l[0].x +
            " " +
            l[0].y +
            " " +
            l[1].x +
            " " +
            l[1].y +
            "L" +
            l[2].x +
            " " +
            l[2].y +
            "C" +
            l[3].x +
            " " +
            l[3].y
          );
        })
        .join(" ") +
      " " +
      last_line[0].x +
      " " +
      last_line[0].y +
      " " +
      last_line[1].x +
      " " +
      last_line[1].y +
      "L" +
      last_line[2].x +
      " " +
      last_line[2].y +
      "Z"
    );
  }

  function generatePentagonPath(radius, borderRadius = 4) {
    return generatePathPoints([radius, radius, radius, radius, radius], (borderRadius = 4));
  }
</script>

<style lang="scss" scoped></style>
